module.exports = __webpack_public_path__ + "img/kazakhstan.4309e692.svg";